import { matchPath } from 'react-router-dom';
import { Location } from 'history';

export const handleActivePath = (path: string, location: Location): boolean => {
  return Boolean(matchPath(location.pathname, path));
};
